import { useAosSubscriptionContext } from "./aosSubscriptionContext";
export default function useLogOut() {
    var navigate = useAosSubscriptionContext().navigate;
    var doLogout = function (_a) {
        var cognitoHostedUILogoutUrl = _a.cognitoHostedUILogoutUrl, cognitoClientId = _a.cognitoClientId, backUrl = _a.backUrl;
        var url = new URL(cognitoHostedUILogoutUrl);
        url.searchParams.append("client_id", cognitoClientId);
        url.searchParams.append("logout_uri", window.location.origin + backUrl);
        var cognitoLogoutUrl = url.toString();
        window.dispatchEvent(new Event("show-loader"));
        navigate(cognitoLogoutUrl, { replace: true });
        setTimeout(function () { return window.dispatchEvent(new Event("hide-loader")); }, 10000);
    };
    return {
        doLogout: doLogout
    };
}
